import { getIsBrandPreview } from "@faire/retailer-visitor-shared/lib/getIsBrandPreview";
import { isLoggedInRetailer } from "@faire/retailer-visitor-shared/lib/isLoggedInRetailer";
export var canShowVideoProducts = function() {
    return getIsBrandPreview() || isLoggedInRetailer();
};
